import { NgClass } from '@angular/common';
import { Component, computed, HostListener, inject, input } from '@angular/core';
import { SwitchBar } from '../switch-bar/switch-bar';

@Component({
  selector: 'ui-switch-bar-option',
  templateUrl: './switch-bar-option.html',
  imports: [NgClass],
  host: {
    '[class]':
      '"px-1 py-2 rounded-md flex items-center justify-center " + selectedClass() + " " + disabledClass()',
  },
})
export class SwitchBarOption {
  private switchBar = inject(SwitchBar, {
    optional: true,
  });

  value = input<unknown>(undefined);
  disabled = input<boolean>(false);
  mode = input<'default' | 'primary' | 'destructive'>('default');

  protected name = computed(() => this.switchBar?.name());
  protected selected = computed(() => this.switchBar?.value() === this.value());
  protected isDisabled = computed(() => this.disabled() || !!this.switchBar?.disabled());

  protected selectedClass = computed(() =>
    this.selected()
      ? {
          default: 'bg-surface dark:bg-surface-darkmode',
          primary: 'bg-primary dark:bg-primary-darkmode',
          destructive: 'bg-error dark:bg-error-darkmode',
        }[this.mode()]
      : '',
  );
  protected disabledClass = computed(() =>
    this.isDisabled() ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
  );

  @HostListener('click', ['$event'])
  protected onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDisabled()) {
      return;
    }
    this.switchBar?.onRadioChange(this.value());
  }
}
